import { gql } from "@apollo/client";

export const CREATE_SERVICE = gql`
  mutation createService($data: CreateServiceInput!) {
    createService(data: $data) {
      id
      name
      icon_path
      image_path
      capacity
      base_rate
      minimum_price
    }
  }
`;

export const UPDATE_SERVICE = gql`
  mutation updateService($data: UpdateServiceInput!) {
    updateService(data: $data) {
      id
      name
      icon_path
      image_path
      capacity
      base_rate
      minimum_price
    }
  }
`;

export default CREATE_SERVICE;
